import React from 'react';
import { Helmet } from 'react-helmet';
import MasterGamesList from '../data/MasterGamesList';
import ProvidersData from '../data/ProvidersData';

export default function TopGamesRtp() {
    const currentPath = window.location.pathname;
    const currentDomain = window.location.origin;

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Top Games with RTP</title>
                <link rel="icon" href="/images/fav.webp" sizes="32x32" />
                <meta
                    name="description"
                    content="Explore top casino games with RTP information at FGH. Browse available games from your favorite providers."
                />
                <link rel="canonical" href={`${currentDomain}${currentPath}`} />
            </Helmet>

            <section className="main-body-content main-container-global-adjusted-padding">
                <div className="fgh-slot-games-page-main">
                    <div className="fgh-section-margin fgh-home-provider-games">
                        <ProvidersData />
                    </div>

                    <div className="fgh-slots-games">
                        <MasterGamesList
                            rtpGamesOnly="on"
                            topGamesRtp="on"
                            rtpProvidersOnly="on"
                            tools="on"
                            limit={50}
                            subtext="Explore available games with RTP information"
                            headerText="Top Games Today - Play Now"
                            headerTag="h2"
                        />
                    </div>
                </div>
            </section>
        </>
    );
}
